module.exports = __webpack_public_path__ + "static/media/icon-vie-creche.e8bf6a08.svg";